module.exports = __webpack_public_path__ + "static/media/companyCeoImg_1.799efcc3.png";